import { FEATURES, FEATURE_SECTIONS } from '../const/features'
import { IMy, TRole } from '../../model/types'
import { hasFeature } from './hasFeature'

const SHIFT_ROLES: TRole[] = [
    'super_admin',
    'admin',
    'assistant',
    'coordinator',
    'curator',
]

export const canViewShiftSection = (my: IMy): boolean => {
    return SHIFT_ROLES.includes(my.role)
        && hasFeature(my, FEATURE_SECTIONS.SHIFTS)
        && hasFeature(my, FEATURES.SHIFTS.READ)
}
